import { Autocomplete, TextField } from '@mui/material';
import { generatePath, useNavigate, useParams } from 'react-router';
import { useSalonStore } from '../../../store';
import { useEffect } from 'react';
import { useNotification } from '../../Notification';
import Cookies from 'js-cookie';
import URLs from '../../../pages/URLs';
import { decodeHtml } from '../../../utils/decodeHtml';
import { useTranslation } from 'react-i18next';
import { BASE_FIELD_BACKGROUND_COLOR } from '../../../themes/tokens';

export const SalonSelect = () => {
  const { salonId } = useParams();
  const navigate = useNavigate();
  const { showMessage } = useNotification();
  const { t } = useTranslation();

  const { salonList, fetchSalonList } = useSalonStore();

  useEffect(() => {
    const userId = Cookies.get('user_id');

    fetchSalonList(userId, showMessage, navigate);
  }, []);

  return (
    <Autocomplete
      sx={{
        backgroundColor: BASE_FIELD_BACKGROUND_COLOR,
        '.MuiInputBase-formControl': {
          borderRadius: '8px',
        },
      }}
      options={salonList}
      getOptionLabel={(opt) => {
        return decodeHtml(opt.title);
      }}
      value={salonId ? salonList.find((salon) => salon.id === salonId) || null : null}
      onChange={(_e, value) => {
        navigate(generatePath(URLs.SalonDashboard, { salonId: value ? value.id : '' }));
      }}
      renderInput={(params) => <TextField label={t('salon')} variant="outlined" {...params} />}
    />
  );
};
